import { ADD_PROJECTS } from '../actions/constants';
import { SET_FASTEN_CONNECTIONS, SET_FASTEN_SYNCING, SET_FASTEN_STATUS, SET_FASTEN_EVENTS, SET_FASTEN_ERROR } from '../actions/fasten';

const initial = { connections: {}, syncing: false, status: null, events: [], error: null };

const fastenReducer = (state = initial, { type, payload }) => {
  switch (type) {
    case SET_FASTEN_CONNECTIONS:
      return { ...state, connections: { ...state.connections, [payload.project_id]: payload.connections } };
    case SET_FASTEN_SYNCING:
      return { ...state, syncing: payload };
    case SET_FASTEN_STATUS:
      return { ...state, status: payload };
    case SET_FASTEN_EVENTS:
      return { ...state, events: payload };
    case SET_FASTEN_ERROR:
      return { ...state, error: payload };
    case ADD_PROJECTS:
      return { ...initial };
    case 'CLEAR_ALL':
      return initial;
    default:
      return state;
  }
};

export default fastenReducer;
